
import Vue from 'vue'
import VueI18n from 'vue-i18n';
//语言包
import LangZhCHS from '../lang/zhCHS.js'
import LangZhCHT from '../lang/zhCHT.js'

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: 'zhCHS',
    messages:{
        'zhCHS': LangZhCHS,
        'zhCHT': LangZhCHT
    },
    silentTranslationWarn: true
});
export default i18n;